const DashboardIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      role="img"
      aria-hidden="true"
      width="141"
      height="102"
      viewBox="0 0 141 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M131.152 100.35H9C4.58172 100.35 1 96.7686 1 92.3503L1 19.7614L1 9C1 4.58172 4.58173 1 9.00001 1L47.4772 1L131.152 1C135.571 1 139.152 4.58173 139.152 9V19.7614V92.3504C139.152 96.7686 135.571 100.35 131.152 100.35Z"
        fill="url(#paint0_linear_14035_4868)"
      />
      <path
        d="M11.6599 65.3858H36.8173M11.6599 53.8731H36.8173M11.6599 42.3604H36.8173M11.6599 31.2741H36.8173M1 19.7614L1 9C1 4.58172 4.58173 1 9 1L47.4772 1M1 19.7614L1 92.3503C1 96.7686 4.58172 100.35 9 100.35H131.152C135.571 100.35 139.152 96.7686 139.152 92.3503V19.7614M1 19.7614H54.2995M139.152 19.7614V9C139.152 4.58173 135.571 1 131.152 1L47.4772 1M139.152 19.7614L54.2995 19.7614M47.4772 1L54.2995 19.7614"
        stroke="var(--theme-primary)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <mask id="path-3-inside-1_14035_4868" fill="white">
        <path d="M42.7858 10.3799C42.7858 13.2058 40.4949 15.4967 37.669 15.4967C34.8431 15.4967 32.5522 13.2058 32.5522 10.3799C32.5522 7.55403 34.8431 5.26318 37.669 5.26318C40.4949 5.26318 42.7858 7.55403 42.7858 10.3799ZM35.6223 10.3799C35.6223 11.5103 36.5386 12.4266 37.669 12.4266C38.7994 12.4266 39.7157 11.5103 39.7157 10.3799C39.7157 9.24958 38.7994 8.33324 37.669 8.33324C36.5386 8.33324 35.6223 9.24958 35.6223 10.3799Z" />
      </mask>
      <path
        d="M42.7858 10.3799C42.7858 13.2058 40.4949 15.4967 37.669 15.4967C34.8431 15.4967 32.5522 13.2058 32.5522 10.3799C32.5522 7.55403 34.8431 5.26318 37.669 5.26318C40.4949 5.26318 42.7858 7.55403 42.7858 10.3799ZM35.6223 10.3799C35.6223 11.5103 36.5386 12.4266 37.669 12.4266C38.7994 12.4266 39.7157 11.5103 39.7157 10.3799C39.7157 9.24958 38.7994 8.33324 37.669 8.33324C36.5386 8.33324 35.6223 9.24958 35.6223 10.3799Z"
        fill="url(#paint1_linear_14035_4868)"
        stroke="var(--theme-primary)"
        strokeWidth="4"
        mask="url(#path-3-inside-1_14035_4868)"
      />
      <mask id="path-4-inside-2_14035_4868" fill="white">
        <path d="M29.9943 10.3799C29.9943 13.2058 27.7034 15.4967 24.8775 15.4967C22.0516 15.4967 19.7607 13.2058 19.7607 10.3799C19.7607 7.55403 22.0516 5.26318 24.8775 5.26318C27.7034 5.26318 29.9943 7.55403 29.9943 10.3799ZM22.8308 10.3799C22.8308 11.5103 23.7471 12.4266 24.8775 12.4266C26.0079 12.4266 26.9242 11.5103 26.9242 10.3799C26.9242 9.24958 26.0079 8.33324 24.8775 8.33324C23.7471 8.33324 22.8308 9.24958 22.8308 10.3799Z" />
      </mask>
      <path
        d="M29.9943 10.3799C29.9943 13.2058 27.7034 15.4967 24.8775 15.4967C22.0516 15.4967 19.7607 13.2058 19.7607 10.3799C19.7607 7.55403 22.0516 5.26318 24.8775 5.26318C27.7034 5.26318 29.9943 7.55403 29.9943 10.3799ZM22.8308 10.3799C22.8308 11.5103 23.7471 12.4266 24.8775 12.4266C26.0079 12.4266 26.9242 11.5103 26.9242 10.3799C26.9242 9.24958 26.0079 8.33324 24.8775 8.33324C23.7471 8.33324 22.8308 9.24958 22.8308 10.3799Z"
        fill="url(#paint2_linear_14035_4868)"
        stroke="var(--theme-primary)"
        strokeWidth="4"
        mask="url(#path-4-inside-2_14035_4868)"
      />
      <mask id="path-5-inside-3_14035_4868" fill="white">
        <path d="M17.2023 10.3799C17.2023 13.2058 14.9114 15.4967 12.0855 15.4967C9.2596 15.4967 6.96875 13.2058 6.96875 10.3799C6.96875 7.55403 9.2596 5.26318 12.0855 5.26318C14.9114 5.26318 17.2023 7.55403 17.2023 10.3799ZM10.0388 10.3799C10.0388 11.5103 10.9551 12.4266 12.0855 12.4266C13.2159 12.4266 14.1322 11.5103 14.1322 10.3799C14.1322 9.24958 13.2159 8.33324 12.0855 8.33324C10.9551 8.33324 10.0388 9.24958 10.0388 10.3799Z" />
      </mask>
      <path
        d="M17.2023 10.3799C17.2023 13.2058 14.9114 15.4967 12.0855 15.4967C9.2596 15.4967 6.96875 13.2058 6.96875 10.3799C6.96875 7.55403 9.2596 5.26318 12.0855 5.26318C14.9114 5.26318 17.2023 7.55403 17.2023 10.3799ZM10.0388 10.3799C10.0388 11.5103 10.9551 12.4266 12.0855 12.4266C13.2159 12.4266 14.1322 11.5103 14.1322 10.3799C14.1322 9.24958 13.2159 8.33324 12.0855 8.33324C10.9551 8.33324 10.0388 9.24958 10.0388 10.3799Z"
        fill="url(#paint3_linear_14035_4868)"
        stroke="var(--theme-primary)"
        strokeWidth="4"
        mask="url(#path-5-inside-3_14035_4868)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14035_4868"
          x1="0.999997"
          y1="0.900133"
          x2="139.152"
          y2="99.5804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--theme-primary)" stopOpacity="0.2" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.05" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14035_4868"
          x1="32.5522"
          y1="5.2529"
          x2="44.7805"
          y2="11.5341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.06" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_14035_4868"
          x1="19.7607"
          y1="5.2529"
          x2="31.989"
          y2="11.5341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.06" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_14035_4868"
          x1="6.96875"
          y1="5.2529"
          x2="19.197"
          y2="11.5341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.06" />
          <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DashboardIcon;
